module.exports = __webpack_public_path__ + "img/driverLicensePic.f33e1fb1.png";